import { cn } from "@/lib/utils";

/**
 * Qahva sonini ko'rsatadigan tanga.
 *
 * Qahva bu yerda valyuta, ichimlik emas: balans, tarif va tranzaksiyalar
 * qahvada o'lchanadi. Shuning uchun son yonida piyola emas — logotipning
 * "Q" belgisi o'yilgan tanga turadi.
 *
 * O'yilgan joylar shaffof (`evenodd`), rang esa `currentColor` dan
 * keladi: tanga qanday fonda va qaysi rejimda bo'lishidan qat'i nazar
 * bir xil ishlaydi.
 *
 * Geometriya `LogoMark` dan olingan: belgi 0.8 ga kichraytirilib, radiusi
 * 120 bo'lgan diskka joylashtirilgan. Dumning halqa ichidagi qismi
 * chizilmaydi — u yer allaqachon o'yilgan, ustiga chizilsa `evenodd`
 * uni qaytadan to'ldirib yuboradi.
 */
const COIN_PATH = [
  "M 8 128 A 120 120 0 1 0 248 128 A 120 120 0 1 0 8 128 Z",
  "M 49.6 128 A 78.4 78.4 0 1 0 206.4 128 A 78.4 78.4 0 1 0 49.6 128 Z",
  "M 67.2 128 A 60.8 60.8 0 1 0 188.8 128 A 60.8 60.8 0 1 0 67.2 128 Z",
  "M 199.11 161.02 L 213.98 195.88 L 195.88 213.98 L 161.02 199.11 A 78.4 78.4 0 0 0 199.11 161.02 Z",
].join(" ");

export function CoffeeCoin({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 256 256"
      className={cn("size-4 shrink-0", className)}
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <path d={COIN_PATH} fill="currentColor" fillRule="evenodd" />
    </svg>
  );
}
